import { Field, FieldArray, Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import React from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import * as yup from 'yup';
import { editSection } from './ApiSections';
import PecnilAlt from '../../../SharedComponents/Svg/PencilAlt';
import { getLanguages } from '../../Categories/ApiCategories';
import Modal from '../../../SharedComponents/Modal';
import Loading from '../../../SharedComponents/Loading';
import { useTranslation } from 'react-i18next';
import LanguageList from '../../../SharedComponents/LanguageList';

export default function EditSection(props) {
  const [isOpen, setIsOpen] = useState(false);
  const { id } = props.id ? props : 1;
  const { section } = props;

  const queryClient = useQueryClient();
  // Mutate Data to Create New Category
  const editSectionMutation = useMutation(editSection, {
    onSuccess: async (data) => {
      if (data.isDone) {
        queryClient.invalidateQueries(['sections']);
        setIsOpen(false);
      }
    },
  });

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="bg-green-100 text-green-800 hover:bg-green-200  p-1 rounded transition duration-300 ease-in-out"
      >
        <PecnilAlt className="w-5 h-5" />
      </button>

      {isOpen && (
        <ModalContainer
          id={id}
          editSectionMutation={editSectionMutation}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          section={section}
        />
      )}
    </>
  );
}

const ModalContainer = (props) => {
  const { isOpen, setIsOpen, editSectionMutation, section } = props;
  const [languageId, setLanguageId] = useState(1);
  const { t, i18n } = useTranslation();
  // Query Data To Fetch Languages
  const { data, isLoading, isError } = useQuery('languages', getLanguages, {
    staleTime: 360000000,
  });
  useEffect(() => {
    setLanguageId(data?.data.sort((a, b) => (a.orderNum > b.orderNum ? 1 : -1))[0].id);
  }, [data]);

  // create a loop for localisation
  const pgSectionLngs = data?.data?.map((language) => ({
    languageId: language.id,
    name: '',
  }));
  const initialValues = {
    id: section.id,
    sectionStyle: section.sectionStyle,
    sectionTypeId: section.sectionTypeId,
    isActive: section.isActive,
    orderNum: section.orderNum,
    pgPageId: section.pgPageId,
    pgSectionLngs: section.pgSectionLngs,
  };

  return (
    <>
      {data && data.data && (
        <Formik validateOnBlur={false} validateOnChange={false} initialValues={initialValues}>
          {({ values, setFieldValue, errors }) => {
            const onSubmit = async (e) => {
              try {
                await editSectionMutation.mutate(values);
              } catch (error) {
                console.log('error', error);
              }
            };
            return (
              <Form>
                <Modal
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  onSubmit={onSubmit}
                  title={t('Edit Section')}
                  isLoading={editSectionMutation.isLoading}
                  add={true}
                  submitType="button"
                >
                  {isLoading && <Loading />}
                  {isError && 'error'}

                  {data && (
                    <LanguageList
                      className="flex transform translate-y-1 relative z-10 mb-4"
                      languages={data?.data}
                      languageId={languageId}
                      setLanguageId={setLanguageId}
                    >
                      <hr className="border w-full absolute bottom-0 left-0 z-0" />
                    </LanguageList>
                  )}

                  {/* Submit Form */}

                  {values &&
                    values.pgSectionLngs &&
                    values?.pgSectionLngs.map((asset, index) => (
                      <FieldArray
                        key={index}
                        name="pgSectionLngs"
                        render={(arrayHelpers) => (
                          <>
                            {languageId === asset.languageId && (
                              <>
                                <label>
                                  <b
                                    className={`font-semibold block text-gray-700 ${
                                      i18n.language === 'en' ? '' : 'text-right'
                                    }`}
                                  >
                                    {t('Title')}
                                  </b>
                                  <Field
                                    className="border rounded  w-full mb-4 p-1"
                                    type="text"
                                    name={`pgSectionLngs[${index}].title`}
                                  />
                                </label>
                              </>
                            )}
                          </>
                        )}
                      />
                    ))}
                  <label>
                    <b className={`font-semibold block text-gray-700 ${i18n.language === 'en' ? '' : 'text-right'}`}>
                      {t('Section Style')}
                    </b>
                    <Field className="border rounded  w-full mb-4 p-1" type="text" name={`sectionStyle`} />
                  </label>
                  <label>
                    <b className={`font-semibold block text-gray-700 ${i18n.language === 'en' ? '' : 'text-right'}`}>
                      {t('Order Number')}
                    </b>
                    <Field className="border rounded  w-full mb-4 p-1" type="number" name={`orderNum`} />
                  </label>
                </Modal>
              </Form>
            );
          }}
        </Formik>
      )}
    </>
  );
};
